import { render, staticRenderFns } from "./BaseSocials.vue?vue&type=template&id=cc57a180&"
import script from "./BaseSocials.vue?vue&type=script&lang=js&"
export * from "./BaseSocials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports